import React, { useState, useEffect } from "react";
import { connect } from "react-redux";

import { withStyles, makeStyles } from "@material-ui/core/styles";
import { Accordion as MuiExpansionPanel, Button,Typography, Tabs, Tab, Box, useTheme, useMediaQuery } from "@material-ui/core";
import { green } from "@material-ui/core/colors";
import SettingsPhoneIcon from '@mui/icons-material/SettingsPhone';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
// import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';

//import SearchComponent from './Search';
import PreviewLeads from "./PreviewLeads";

//store
import * as actions from "../../../../store/actions/actionIndex";

import LeadBucket from "./LeadBucket";
import CallHistory from "./CallHistory";
import PreviewAgentHistory from "./PreviewAgentHistory";

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.paper,
    position: "relative",
    minHeight: 120,
    marginTop: "44px",
    height: "100%",
  },
  selectInput: {
    padding: 10,
    paddingInlineEnd: 25,
    "&:focus": {
      backgroundColor: "white",
    },
  },
  title: {
    display: "block",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
    marginBottom: theme.spacing(1),
  },
  fab: {
    position: "absolute",
    //bottom: theme.spacing(2),
    top: theme.spacing(8),
    insetInlineEnd: theme.spacing(2),
  },
  fabGreen: {
    color: theme.palette.common.white,
    backgroundColor: green[500],
    "&:hover": {
      backgroundColor: green[600],
    },
  },
  AutoModeButton: {
    margin: "14px 0",
    textAlign: "end",
    display: "flex",
    justifyContent: "space-between",
  },
  Button: {
    height: "40px",
    color: "#526FEB",
    fontWeight: "400",
    textTransform: "capitalize",
    fontSize: "16px",
    "&:hover": {
      backgroundColor: "#526FEB",
      color: "white",
    },
  },
  SearchButton: {
    height: "35px",
    color: "#ffffff",
    backgroundColor: "#00000017",
    border: "none",
    borderRadius: "50%",
    padding: "0",
    minWidth: "35px",
    marginInlineEnd: "20px",
    "&:hover": {
      backgroundColor: "#ffffff",
      color: "#0c82da",
    },
  },
  callDialog: {
    //position:"fixed",
    insetInlineEnd: "50px",
  },
  DispositionTitle: {
    color: "white",
    backgroundColor: "#0c82da",
    // backgroundColor: "#242a5a",
    fontSize: "15px",
    lineHeight: "18px",
    marginBottom: -1,
    padding: "16px 25px 16px 24px",
    minHeight: 40,
    "&$expanded": {
      minHeight: 40,
    },
  },
  tabsIcon: {
    marginInlineEnd: "8px",
    [theme.breakpoints.down("xs")]: {
          marginInlineEnd: "4px",
      },
  },
}));

const Accordion = withStyles({
  root: {
    border: "1px solid rgba(0, 0, 0, .125)",
    boxShadow: "none",
    "&:not(:last-child)": {
      borderBottom: 0,
    },
    "&:before": {
      display: "none",
    },
    "&$expanded": {
      margin: "auto",
    },
  },
  expanded: {},
})(MuiExpansionPanel);

const CustomTab = withStyles((theme) => ({
  root: {
    padding: '8px 16px',
    backgroundColor: '#0a82da',
    marginInlineEnd: 4,
    borderRadius: '4px 4px 0 0',
    // width: "350px",
  color: "#fff",
  [theme.breakpoints.down("xs")]: {
          padding: '4px 7px',
      },
  },
  selected: {
    backgroundColor: '#ffffff',
    borderBottom: '2px solid transparent',

  },
  wrapper: {
    fontSize: '16px',
    fontWeight: 600,
    textTransform: 'none',
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.down("xs")]: {
      fontSize: '14px',
      fontWeight: 500,
      },
  },
}))(Tab);



function PreviewModeTab(props) {
  const classes = useStyles();
  const theme = useTheme();

  //const { agentConf } = props;
  const [open, setOpen] = useState(false);
  const [callHistory, setCallHistory] = useState([])
   const [tabIndex, setTabIndex] = useState(0);
   const isMobile = useMediaQuery(theme.breakpoints.down('xs'));

  useEffect(() => {
    if (open && props.agentState !== "FREE") {
      setOpen(false);
    }
  }, [props.agentState, open, setOpen]);

  const modeChange = () => {
    if (props.autoMode === "1") {
      props.onModeChange(props.agentId, "AUTO_PREVEIW_DISABLE", props.agentState);
    } else {
      props.onModeChange(props.agentId, "AUTO_PREVEIW_ENABLE", props.agentState);
    }
  };

    const handleTabChange = (event, newValue) => {
    setTabIndex(newValue);
  };


  return (
    <div className={classes.root}>
      {/* Tabs */}
     <Box
      sx={{
        borderTop: '4px solid #ddd',
        backgroundColor: '#0a82da',
      }}
    style={{
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    paddingInlineStart: "10px",
    paddingInlineEnd: "10px",
    backgroundColor: "#0a82da"
    }}
    >
<Tabs
  value={tabIndex}
  onChange={handleTabChange}
  aria-label="styled tabs"
  textColor="primary"
  TabIndicatorProps={{ style: { display: 'none' } }}
  variant="fullWidth" 
  sx={{ width: "100%" }}
>
  <CustomTab
    wrapped
    sx={{
      flexGrow: 1, 
      minHeight: 60, 
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    }}
    label={
      <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        width="100%" 
      >
        <PersonOutlineIcon className={classes.tabsIcon} />
        Lead Details
      </Box>
    }
  />
  {/* <CustomTab
    wrapped
    sx={{
      flexGrow: 1,
      minHeight: 60,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    }}
    label={
      <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        width="100%"
      >
        <SettingsPhoneIcon className={classes.tabsIcon} />
        Recent Calls
      </Box>
    }
  /> */}
  <CustomTab
    wrapped
    sx={{
      flexGrow: 1,
      minHeight: 60,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    }}
    label={
      <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        width="100%"
      >
        <SettingsPhoneIcon className={classes.tabsIcon} />
        Calls History
      </Box>
    }
  />
</Tabs>


{/* <Button
	variant="outlined"
	size="small"
	className={classes.Button}
	onClick={modeChange}
	style={{
		textTransform: 'capitalize',
		color: '#fff',
		border: '1px solid #fff',
		marginInlineStart: '10px',
		margin: '-1px 0',
		fontSize: '16px',
		minWidth: isMobile ? 'auto' : '64px'
	}}
>
{
	isMobile ? (
	<>
		{props.agentMode === 'PREVIEW' && props.autoMode === '1' ? (
					<MotionPhotosAutoIcon />
					) : (
					<MotionPhotosAutoOutlinedIcon />
				)}
				</>
		) : (
			<>
				{props.agentMode === 'PREVIEW' && props.autoMode === '1' ? (
					<>
						<MotionPhotosAutoIcon style={{marginInlineEnd: "0.25rem"}} /> Disable Auto Mode
					</>
					) : (
					<>
						<MotionPhotosAutoOutlinedIcon style={{marginInlineEnd: "0.25rem"}} /> Enable Auto Mode
					</>
				)}
			</>
		)
}
	
</Button> */}

</Box>
      {/* Tab Panels */}
      {tabIndex === 0 && (
       <>
           <PreviewLeads />
     </>
      )}

      {/* {tabIndex === 1 && (
        <div>
       <div className="leadbucket-data">
      {!props.loading && Array.isArray(props.recentData) && props.recentData.length ? (
          <CallHistory
            maxHeight="400px"
            calls={props.recentData}
          />
          ) : (
          "No recent calls to display"
          )}
     </div>
        </div>
      )} */}

      {tabIndex === 1 && (
        <div>
          {/* <Typography className={classes.DispositionTitle}>
            Recent Call History
          </Typography> */}
     <PreviewAgentHistory
          />
        </div>
      )}

  
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
 		agentId: state.agentData.agentId,
		agentConf: state.agentConfig.agentConf,
		agentMode: state.agentData.dialerType,
		autoMode: state.agentData.autoMode,
		agentState: state.agentData.agentState,
		modeError: state.agentMode.error,
		modeLoading: state.agentMode.loading,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onModeChange: (agentId, mode, agentState) => dispatch(actions.modeChange(agentId, mode, agentState)),
   };
};

export default connect(mapStateToProps, mapDispatchToProps)(PreviewModeTab);
